import { IBoltTask, TaskExecutionTypeFieldSchema } from "@bolt/core";
import { useEffect, useState } from "react";
import { useTasks } from "../../hooks/useTasks";

import { TaskExecutionComponentProps } from "./TaskExecutionComponent";
import { AppToasterV2 } from "@ucl/library";
export const useTaskExecutionComponent = (
  props: TaskExecutionComponentProps
) => {
  const [task, setTask] = useState<IBoltTask | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const { fetchTask, completeTask, withdrawTask, reinstateTask, reassignTask } =
    useTasks();

  useEffect(() => {
    getTask();
  }, []);

  const getTask = async () => {
    setIsLoading(true);

    try {
      const res = await fetchTask(props.taskId);
      setTask(res.boltTask);
    } catch (error) {
      AppToasterV2.showFailedActionToaster("Error fetching task");
      console.error("Error fetching task", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTaskComplete = async (
    updatedTaskExecutionTypeFields: TaskExecutionTypeFieldSchema
  ) => {
    setIsLoading(true);

    try {
      // TODO: For now, let's assume we don't need any response from the completeTask.
      await completeTask(props.taskId, updatedTaskExecutionTypeFields);

      AppToasterV2.showSuccessAppToaster("Task Completed");

      if (props.onTaskComplete) {
        await props.onTaskComplete();
      }
    } catch (error) {
      AppToasterV2.showFailedActionToaster("Error completing task");
      console.error("Error completing task", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleWithdraw = async (reason: string) => {
    setIsLoading(true);

    try {
      await withdrawTask(props.taskId, reason);

      AppToasterV2.showSuccessAppToaster("Task Withdrawn");

      if (props.onTaskComplete) {
        await props.onTaskComplete();
      }
    } catch (error) {
      AppToasterV2.showFailedActionToaster("Error withdrawing task");
      console.error("Error withdrawing task", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReassignTask = async (assigneeId: string) => {
    setIsLoading(true);

    try {
      await reassignTask(props.taskId, assigneeId);

      AppToasterV2.showSuccessAppToaster("Task Updated");

      await getTask();
    } catch (error) {
      AppToasterV2.showFailedActionToaster("Error updating task");
      console.error("Error updating task", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReinstate = async () => {
    setIsLoading(true);

    try {
      await reinstateTask(props.taskId);

      AppToasterV2.showSuccessAppToaster("Task Reinstated");

      await getTask();
    } catch (error) {
      AppToasterV2.showFailedActionToaster("Error reinstating task");
      console.error("Error reinstating task", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    task,
    isLoading,
    handleTaskComplete,
    handleWithdraw,
    handleReinstate,
    handleReassignTask,
  };
};
